import { BiImport, BiSpreadsheet } from 'react-icons/bi';

/** O passo que abre a Entrada pelo menu: comum aos tutoriais desta etapa. */
const abrirAEntrada = {
  alvo: 'menu:Entrada',
  titulo: 'Abra a Entrada',
  texto: 'Clique em Entrada. Toda compra entra no estoque por aqui.',
  lado: 'right',
  exigeClique: true,
};

export const entradaNotaFiscal = {
  id: 'entrada-nota-fiscal',
  titulo: 'Dar entrada de uma nota fiscal',
  descricao: 'Importe o XML da NF de compra e os equipamentos aparecem no estoque sem digitação.',
  icone: BiImport,
  exigeAdmin: true,
  passos: [
    abrirAEntrada,
    {
      alvo: 'aba:Importar',
      titulo: 'Importar',
      texto: 'A aba Importar recebe a nota fiscal ou a planilha de equipamentos.',
      lado: 'bottom',
    },
    {
      alvo: 'entrada:xml',
      titulo: 'Nota Fiscal XML',
      texto: 'Clique no cartão Nota Fiscal XML. É a forma preferida: o ERP lê os produtos da nota sozinho.',
      lado: 'bottom',
      exigeClique: true,
    },
    {
      alvo: 'entrada:arquivo',
      titulo: 'Escolha o XML',
      texto:
        'Aqui você escolhe o arquivo XML da NF-e que veio do fornecedor. O ERP mostra os dados da nota e a lista de produtos.',
      fala: 'Aqui você escolhe o arquivo XML da nota fiscal eletrônica que veio do fornecedor. O ERP mostra os dados da nota e a lista de produtos.',
      lado: 'bottom',
    },
    {
      alvo: 'entrada:arquivo',
      titulo: 'Classifique e confirme',
      texto:
        'Em cada produto, informe marca, modelo, o cliente VOXCITY TECNOLOGIA e o anexo. No fim, "Confirmar entrada de estoque" pede o PIN de segurança e grava a entrada.',
      fala: 'Em cada produto, informe marca, modelo, o cliente Vox City Tecnologia e o anexo. No fim, o botão Confirmar entrada de estoque pede o PIN de segurança e grava a entrada.',
      lado: 'bottom',
    },
    {
      alvo: 'aba:Notas Fiscais',
      titulo: 'Confira a nota',
      texto: 'Depois de importar, clique em Notas Fiscais para conferir se a NF entrou.',
      lado: 'bottom',
      exigeClique: true,
    },
    {
      alvo: 'tabela:pesquisar',
      titulo: 'Procure pelo número',
      texto:
        'Digite o número da NF para achá-la. Confira o fornecedor e a quantidade de patrimônios com a nota em papel.',
      lado: 'bottom',
      paciencia: 10000,
    },
    {
      alvo: 'notas:atualizar',
      titulo: 'Atualizar',
      texto: 'Recarrega a lista. Use logo depois de uma importação.',
      lado: 'left',
    },
    {
      alvo: 'tabela:acoes',
      titulo: 'Lixeira',
      texto: 'A lixeira vermelha exclui a NF importada. Não use sem autorização do gestor.',
      lado: 'left',
      pulaSeAusente: true,
    },
  ],
};

export const entradaPlanilha = {
  id: 'entrada-planilha',
  titulo: 'Importar planilha de equipamentos',
  descricao: 'Para aparelhos sem XML: baixe o modelo, preencha série, MAC e etiqueta e importe.',
  icone: BiSpreadsheet,
  exigeAdmin: true,
  passos: [
    abrirAEntrada,
    {
      alvo: 'entrada:equipamentos',
      titulo: 'Equipamentos',
      texto: 'Clique no cartão Equipamentos.',
      lado: 'bottom',
      exigeClique: true,
    },
    {
      alvo: 'entrada:template',
      titulo: 'Baixe o modelo',
      texto:
        'Baixar Template traz a planilha no formato certo. Preencha uma linha por aparelho: nserie, nmac e netiqueta.',
      fala: 'Baixar Template traz a planilha no formato certo. Preencha uma linha por aparelho, com o número de série, o MAC e a etiqueta.',
      lado: 'top',
      avancaAoClicar: true,
    },
    {
      alvo: 'entrada:arquivo',
      titulo: 'Importe a planilha',
      texto:
        'Salve como .xlsx e escolha o arquivo aqui. A seleção global aplica marca, modelo, cliente e anexo a todos de uma vez; confira a lista e confirme os equipamentos.',
      fala: 'Salve como planilha do Excel e escolha o arquivo aqui. A seleção global aplica marca, modelo, cliente e anexo a todos de uma vez. Confira a lista e confirme os equipamentos.',
      lado: 'bottom',
    },
  ],
};
